export type R2HealthStatus = 'up' | 'down';

export type R2HealthReportStatus = 'ok' | 'error' | 'degraded' | 'shutting_down';

export interface IR2HealthCheck
{
    status: R2HealthStatus;
    message?: string;
    statusCode?: number;
    statusText?: string;
}

export interface IR2HealthReport
{
    status: R2HealthReportStatus;
    version?: string;
    info?: Record<string, IR2HealthCheck>;
    error?: Record<string, IR2HealthCheck>;
    details: Record<string, IR2HealthCheck>;
}

export const R2_HEALTH_CHECK = {
    DATABASE: 'database',
    R2_API: 'r2Api',
    AI_API: 'aiApi',
    BILLING_API: 'billingApi',
    SETTINGS_SERVICE: 'settingsService',
    HYPER_ID_API: 'hyperIdApi',
    HYPER_ID: 'hyperId',
} as const;

export type R2HealthCheckName = typeof R2_HEALTH_CHECK[ keyof typeof R2_HEALTH_CHECK ];

export const R2_AGGREGATE_HEALTH_CHECKS = [
    R2_HEALTH_CHECK.R2_API,
    R2_HEALTH_CHECK.AI_API,
    R2_HEALTH_CHECK.BILLING_API,
    R2_HEALTH_CHECK.SETTINGS_SERVICE,
    R2_HEALTH_CHECK.HYPER_ID_API,
    R2_HEALTH_CHECK.HYPER_ID,
] as const;

export type R2AggregateHealthCheckName = typeof R2_AGGREGATE_HEALTH_CHECKS[ number ];

export const R2_HEALTH_PATH = '/api/health';

export const R2_OUTAGE_STATUS = 503;

